import React, {useEffect, useState} from 'react'
import {message, Modal, Select, Space, Table} from "antd"
import {getWalletList, getWalletRecord} from "../../../../../api/clubMemberList"
import Paragraph from "antd/lib/typography/Paragraph"

const ClubMemberFindWallet = ({memberId}) => {

    const [isShow, setIsShow] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [tableIsLoading, setTableIsLoading] = useState(false)
    const [page, setPage] = useState({
        page: 1,
        total: 0,
    })
    const [walletOptions, setWalletOptions] = useState([])
    const [selectedWallet, setSelectedWallet] = useState(null)
    const [walletRecord, setWalletRecord] = useState([])


    const fetchWalletList = async () => {
        setIsLoading(true)
        await getWalletList(memberId).then(res => {
            if (res.list) {
                const options = res.list.map(item => {
                    return {
                        label: item.name,
                        value: item.id
                    }
                })
                setWalletOptions(options)
                setSelectedWallet(options[0].value)
                return
            }
            message.error(`获取钱包信息失败：${res.detail}`)
        }).catch(err => {
            message.error(`获取钱包信息失败：${err.message}`)
        }).finally(() => {
            setIsLoading(false)
        })
    }

    const fetchWalletRecord = async (page) => {
        setTableIsLoading(true)
        await getWalletRecord(memberId, selectedWallet, page).then(res => {
            setWalletRecord(res.list)
            setPage(prevState => {
                return {
                    ...prevState,
                    total: res.total
                }
            })
        }).catch(err => {
            message.error(`获取钱包流水失败：${err.message}`)
        }).finally(() => {
            setTableIsLoading(false)
        })
    }

    useEffect(() => {
        if (isShow && selectedWallet) {
            fetchWalletRecord(1)
        }
    }, [selectedWallet])

    useEffect(() => {
        if (isShow) {
            fetchWalletRecord(page.page)
        }
    }, [page.page])

    const handleClick = async () => {
        setIsShow(true)
        setWalletOptions([])
        setSelectedWallet(null)
        setWalletRecord([])
        await fetchWalletList()
    }


    const columns = [
        {
            title: '钱包名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '期初金额',
            dataIndex: 'init',
            key: 'init',
            render: (text) => {
                return (text / 100).toFixed(2)
            },
        },
        {
            title: '增加金额',
            dataIndex: 'income',
            key: 'income',
            render: (text) => {
                return (text / 100).toFixed(2)
            },
        },
        {
            title: '支出金额',
            dataIndex: 'outcome',
            key: 'outcome',
            render: (text) => {
                return (text / 100).toFixed(2)
            },
        },
        {
            title: '余额',
            dataIndex: 'balance',
            key: 'balance',
            render: (text) => {
                return (text / 100).toFixed(2)
            },
        },
        {
            title: '时间',
            dataIndex: 'ctime',
            key: 'ctime',
        },
        {
            title: '说明',
            dataIndex: 'note',
            key: 'note',
        },
        {
            title: '流水号',
            dataIndex: 'serial_number',
            key: 'serial_number',
            render: (text) => {
                return <Paragraph copyable>{text}</Paragraph>
            }
        },
    ]

    return (
        <div>
            <div onClick={handleClick}>钱包足迹
            </div>
            <Modal
                open={isShow}
                footer={null}
                onCancel={() => setIsShow(false)}
                width={1000}
                title={"钱包足迹"}
            >

                <Select
                    placeholder={"请选择钱包"}
                    style={{width: 300}}
                    options={walletOptions}
                    loading={isLoading}
                    value={selectedWallet}
                    onChange={setSelectedWallet}
                />
                <Table
                    style={{marginTop: 16}}
                    loading={tableIsLoading}
                    columns={columns}
                    dataSource={walletRecord}
                    pagination={{
                        total: page.total,
                        onChange: (value) => setPage(prevState => {
                            return {
                                ...prevState,
                                page: value
                            }
                        })
                    }}
                />

            </Modal>
        </div>
    )
}

export default ClubMemberFindWallet


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/component/ClubMemberFind/component/ClubMemberFindWallet.js